import React, {useEffect} from 'react';
import styled from 'styled-components'
const {kakao} = window;
let map = null
const MapDiv = styled.div`
  width: 100%;
  object-fit: cover;
  margin-top: 37.3px;
  height: 300px;
`
function NaverMapMobile() {
  useEffect(() => {
    
    var map = new naver.maps.Map('map', {
      center: new naver.maps.LatLng(37.5559642, 126.9197038),
      zoom: 16
    });
    
    var marker = new naver.maps.Marker({
        position: new naver.maps.LatLng(37.5559642, 126.9197038),
        map: map
    });

      return () => {
      }
  }, [])

  return (
    
    <MapDiv id="map" />
  )
}

export default NaverMapMobile;
